import * as React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectHasOrg } from "../../store/userDataSlice";
import { selectOrg } from "../../store/contextSlice";

export const ConsoleRoute: React.FC = () => {
  const hasOrg = useAppSelector(selectHasOrg);
  const org = useAppSelector(selectOrg);

  if (!hasOrg) {
    console.log("no org item, to home");
    return <Navigate to={"/home"} />;
  }

  if (!org) {
    console.log("no org context, to home");
    return <Navigate to={"/home"} />;
  }

  return <Navigate to={`/console/org/${org}/health`} />;
};
